import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { MdMenu } from "react-icons/md";

export default function AdminTopbar({ isMobile, onMenuClick }) {
    return (
        <Box
            sx={{
                height: 64,
                borderBottom: "1px solid var(--border)",
                display: "flex",
                alignItems: "center",
                px: { xs: 2, md: 3 },
                gap: 1,
                backgroundColor: "var(--branco)",
                position: "sticky",
                top: 0,
                zIndex: 1200,
            }}
        >
            {isMobile && (
                <IconButton onClick={onMenuClick} sx={{ mr: 0.5 }}>
                    <MdMenu size={22} />
                </IconButton>
            )}

            <Typography sx={{ fontWeight: 700, color: "var(--cise-text)" }}>
                Cultura Inglesa de Sergipe
            </Typography>
        </Box>
    );
}